import { getSavedState, saveState } from '@utils/user-info.js'

export const state = {
    tags: [],
    resources: [],
    addedGoogleDoc: getSavedState('resources.addedGoogleDoc'),
}

export const mutations = {
    SET_TAGS(state, { tags }) {
        state.tags = tags
    },
    SET_RESOURCES(state, { resources }) {
        state.resources = resources
    },
    SET_ADDED_GOOGLE_DOC(state, addedGoogleDoc) {
        state.addedGoogleDoc = addedGoogleDoc;
        saveState('resources.addedGoogleDoc', addedGoogleDoc)
    }
}

export const getters = {
    tags(state) {
        return state.tags
    },
    resources(state) {
        return state.resources
    },
    addedGoogleDoc(state) {
        return state.addedGoogleDoc
    }
}

export const actions = {
    setTags({ commit }, payload) {
        commit('SET_TAGS', payload)
    },
    setResources({ commit }, payload) {
        commit('SET_RESOURCES', payload)
    },
    setAddedGoogleDoc({ commit }, payload) {
        commit('SET_ADDED_GOOGLE_DOC', payload)
    },
}
